module.exports = __webpack_public_path__ + "img/logo.59a2cd8b.png";